import React from 'react';
import styles from './HomePage.module.css';

import CondText from '../../Components/SideBar/assets/icons/condtext.png';
import LayoutDefault from '../../Components/LayoutDefault/LayoutDefault';
import { useNavigate } from "react-router-dom";

function HomePage() {
  const navigate = useNavigate();

  return (
    <LayoutDefault>
      <div className={styles.textContent}>
        <h1>
          Transforme a comunicação do seu condomínio com <span className={styles.highlight}>inteligência instantânea!</span>
        </h1>
        <p>Atenda moradores, gerencie solicitações e facilite a vida no condomínio 24h por dia.</p>
        <button onClick={() => navigate("/login")}>
          Começar Agora
        </button>
      </div>
      <div className={styles.imageContent}>
        <img src={CondText} alt="Imagem explicativa sobre o CondoBot" className={styles.imageImg} />
      </div>
    </LayoutDefault>
  );
}

export default HomePage;
